import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconList } from '../../../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useApiListSaveItem } from '../../../../../../api-new/state/content'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { Menu, MenuAdd, MenuDelete, MenuEdit } from '../../../../../../shared/menu/menu'
import { ColumnFormat, ColumnMenu, ColumnText } from '../../../../../../shared/table-builder/table-columns'
import { Route, useRouteMatch } from '../../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { NodeSaveItemAdd } from './node-save-item-add'
import { NodeSaveItemEdit } from './node-save-item-edit'

export const NodeSaveItemList = ({ nodeID }) => {
  const { url } = useRouteMatch()

  const apiListSaveItem = useApiListSaveItem()

  const handleReady = () => apiListSaveItem.get(`${nodeID}/node`)

  const handleDelete = id => apiListSaveItem.delete(id)

  const HeaderMenu = () =>
    <Menu>
      <MenuAdd text="add" to={`${url}/add`} show pin />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="save system configuration">
        <CardFullHeightScrollY title="save system configuration" HeaderMenu={HeaderMenu}>
          <TableAgClient apiList={apiListSaveItem} onReady={handleReady}>
            <ColumnText field="name" />
            <ColumnText field="type" />
            <ColumnFormat field="value" render={formatRender} />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuEdit to={`${url}/edit/${row.id}`} show />
                  <MenuDelete onClick={() => handleDelete(row.id)} show />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/add`}>
        <NodeSaveItemAdd nodeID={nodeID} parentURL={url} />
      </Route>

      <Route path={`${url}/edit/:id`}>
        <NodeSaveItemEdit nodeID={nodeID} parentURL={url} />
      </Route>
    </React.Fragment>
  )
}

const formatRender = row => {
  switch (typeof row.value) {
    case 'string':
    case 'number':
      return (
        <span>
          {row.value}
        </span>
      )
    case 'boolean':
      return row.value === true ? <span>true</span> : <span>false</span>
    case 'object':
      return (
        <span>
          {JSON.stringify(row.value).replace(/"/g, '').replace(/,/g, ', ')}
        </span>
      )
    default:
      return <span>UNKNOWN</span>
  }
}
